import StudioIamSection from "../../../components/midpoint/clientViews/studio/StudioIamSection";
import { ClientViewIamApiProvider } from "../../../contexts/ClientViewIamApiContext";
import * as clientViewIamApi from "../../../api/clientViewIamApi";
import { AUTOMAP_CLIENT_VIEW_SLUG } from "../../../constants/automapPartnerPortalConfig";
import { useAutoMapaPartnerClientView } from "../../../hooks/useAutoMapaPartnerClientView";
import "../../../styles/clientViewStudio.css";

export default function AutoMapaAccessIamPage() {
  const { clientViewId, loading, error } = useAutoMapaPartnerClientView(AUTOMAP_CLIENT_VIEW_SLUG);

  if (loading) {
    return <p className="muted panel-card">Loading access settings…</p>;
  }

  if (!clientViewId) {
    return (
      <div className="panel-card automap-access-iam">
        <h2>No client view assigned</h2>
        <p className="muted">
          {error ||
            "Your partner account does not have access to the AutoMapa client view yet."}
        </p>
      </div>
    );
  }

  return (
    <div className="client-portal-page cm-iam-page automap-access-iam">
      <header className="cm-iam-page__header panel-card">
        <p className="cm-iam-page__eyebrow">Identity &amp; access</p>
        <h1>Access &amp; IAM</h1>
        <p className="cm-iam-page__subtitle">
          Invite portal users, assign roles, and manage access for the AutoMapa client view.
        </p>
      </header>

      <ClientViewIamApiProvider api={clientViewIamApi}>
        <StudioIamSection clientViewId={clientViewId} canManage variant="portal" />
      </ClientViewIamApiProvider>
    </div>
  );
}
